import { Observable, throwError as observableThrowError } from 'rxjs';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, map } from 'rxjs/operators';

import { isNullOrUndefined } from '../../../util/is-null-or-undefined.util';

import { MensagensService } from '../../../constantes/mensagens.service';
import { RespostaLoginCharon } from '../../charon/models/resposta-login-charon.model';
import { AppSettingsService } from '../../configuracao/services/app-settings.service';
import { RequisicaoLoginCharon } from '../models/requisicao-login-charon.model';
import { SessaoService } from './sessao.service';
import { CharonService, IHttpOptions } from '@quickweb/connect-angular';
import { environment } from '@asset-old/env/environment';

@Injectable(
  {
    providedIn: 'root'
  }
)
export class LogonCharonService {
  private readonly charon = inject(CharonService)
  constructor(
    private http: HttpClient,
    private servicoConfiguracao: AppSettingsService,
    private sessaoService: SessaoService
  ) {}

  /**
   * Método responsável por realizar a autenticação de um usuário no serviço do Caronte
   * @param {RequisicaoLoginCharon} requisicao Dados do Usuário
   * @returns {Observable<RequisicaoLoginCharon>} Dados da Autenticação
   * @memberof LogonRouterService
   */
  async autenticar(
    requisicao: RequisicaoLoginCharon
  ): Promise<RespostaLoginCharon> {
    if (!isNullOrUndefined(requisicao) && !isNullOrUndefined(requisicao.body)) {
      const bodyRequest = JSON.stringify({ body: requisicao.body });   
      //clear session storage
      sessionStorage.removeItem(environment.charon.isCryptographed? this.servicoConfiguracao.environment.charon.id: this.servicoConfiguracao.environment.charon.idNoCrypto);
      this.charon.setCryptography(environment.charon.isCryptographed);

      const httpOptions: IHttpOptions = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
        charonID: environment.charon.isCryptographed ? this.servicoConfiguracao.environment.charon.id : this.servicoConfiguracao.environment.charon.idNoCrypto,
        entryPoint: environment.charon.isCryptographed ? this.servicoConfiguracao.environment.charon.entrypoint : this.servicoConfiguracao.environment.charon.entrypointNoCrypto,
      };

      return this.charon.post('logon', bodyRequest, httpOptions).pipe(
        map((response: any) => {
          const preLogin: RespostaLoginCharon = response.body;
          // prefer sessionId in response body; fall back to header for compatibility
          preLogin.sessionId =
            response.body?.sessionId ||
            response.headers.get(
              this.servicoConfiguracao.environment.charon.session_name,
            );
          preLogin.charonTokenIssuedDate = new Date();
          preLogin.links = response.body.links;
          return preLogin;
        }),
        catchError((erro: any) => {
          return observableThrowError(erro);
        })).toPromise();
    } else {
      return observableThrowError(
        new Error(MensagensService.mensagens.charon.parametrosInvalidos)
      ).toPromise();
    }
  }

  /**
   * Método responsável por realizar a troca de senha de um usuário no serviço do Caronte
   * @param {RequisicaoLoginCharon} requisicao Dados do Usuário
   * @memberof LogonRouterService
   */
  async trocaSenha(
    requisicao: RequisicaoLoginCharon
  ): Promise<RespostaLoginCharon> {
    if (isNullOrUndefined(requisicao) || isNullOrUndefined(requisicao.body)) {
      return observableThrowError(
        new Error(MensagensService.mensagens.charon.parametrosInvalidos)
      ).toPromise();
    }

    const bodyRequest = JSON.stringify({ body: requisicao.body });
    //clear session storage
      sessionStorage.removeItem(environment.charon.isCryptographed? this.servicoConfiguracao.environment.charon.id: this.servicoConfiguracao.environment.charon.idNoCrypto);
      this.charon.setCryptography(environment.charon.isCryptographed);
    const httpOptions: IHttpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      charonID: environment.charon.isCryptographed ? this.servicoConfiguracao.environment.charon.id : this.servicoConfiguracao.environment.charon.idNoCrypto,
      entryPoint: environment.charon.isCryptographed ? this.servicoConfiguracao.environment.charon.entrypoint : this.servicoConfiguracao.environment.charon.entrypointNoCrypto,
    };
    const actionReset =
      this.servicoConfiguracao.environment.charon.action_reset || 'reset';

    return this.charon
      .post(actionReset, bodyRequest, httpOptions)
      .pipe(
        map((response: any) => {
          const preLogin: RespostaLoginCharon = response.body;
          preLogin.sessionId =
            response.body?.sessionId ||
            response.headers.get(
              this.servicoConfiguracao.environment.charon.session_name,
            );
          preLogin.charonTokenIssuedDate = new Date();
          preLogin.links = response.body?.links;
          return preLogin;
        }),
        catchError((erro: any) => observableThrowError(erro))
      )
      .toPromise();
  }
}
